import { Eye, Rocket } from "lucide-react";

export default function Future() {
  return (
    <div className="flex py-20 px-12 bg-[#FFF0EE] gap-8">
      <div
        className="flex flex-col bg-[#FFF8F6] border border-[#E9BCB5]/30 p-8 rounded-xl gap-4 shadow-[#2A1613]/4 shadow-md"
        data-aos="fade-right"
      >
        <div className="bg-[#E60000] w-max p-2 rounded-lg">
          <Eye className="w-5 h-5 text-white" />
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="font-semibold text-xl">Our Vision</h1>
          <p>
            To become a leading global destination for Indonesian language and
            cultural learning, enabling individuals around the world to
            understand, engage with, and form meaningful connections with
            Indonesia.
          </p>
        </div>
      </div>

      <div
        className="flex flex-col bg-[#FFF8F6] p-8 rounded-xl gap-4 border border-[#E9BCB5]/30 shadow-[#2A1613]/4 shadow-md"
        data-aos="fade-left"
      >
        <div className="bg-[#0068F9] w-max p-2 rounded-lg">
          <Rocket className="w-4 h-4 text-white" />
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="font-semibold text-xl">Our Mision</h1>
          <p>
            To provide a refined, personalized approach to Indonesian language
            education through expert native tutors, thoughtful technology, and
            culturally informed learning experiences, making high quality
            language education accessible to learners worldwide.
          </p>
        </div>
      </div>
    </div>
  );
}
